export type BlogPost = {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  category: string;
};

// Images
import heroCashDiscountThumb from "@/assets/hero-cash-discount-thumb.webp";
import koronaPos from "@/assets/korona-pos-bundle.webp";
import onlineOrdering from "@/assets/online-ordering-hero-bg.jpg";
import restaurantProcessing from "@/assets/blog-restaurant-processing.webp";
import retailProcessing from "@/assets/blog-retail-processing.webp";
import smokeshopProcessing from "@/assets/blog-smokeshop-processing.webp";
import cryptoPosGuide from "@/assets/blog-crypto-pos-guide.webp";

export const blogPosts: BlogPost[] = [
  {
    slug: "restaurant-cash-discount-program",
    title: "Tired of High Credit Card Fees? How Restaurants Can Save Thousands with a Compliant Cash Discount Program",
    excerpt:
      "Learn how compliant cash discount programs can help restaurants keep 100% of their profits by offsetting processing costs the right way.",
    image: restaurantProcessing,
    date: "2025-01-15",
    category: "Restaurant Processing",
  },
  {
    slug: "transparent-retail-processing",
    title: "Stop Overpaying: A Retailer's Guide to Transparent Credit Card Processing and POS Systems",
    excerpt:
      "Discover how retail businesses can eliminate hidden processing fees and streamline operations with transparent pricing and integrated POS systems.",
    image: retailProcessing,
    date: "2025-01-16",
    category: "Retail Processing",
  },
  {
    slug: "smoke-shop-processing-expert",
    title: "Beyond Payments: Why Your Smoke Shop Needs a High-Risk Processing Expert and a Specialized POS",
    excerpt:
      "Navigate the complexities of high-risk merchant processing with specialized solutions designed for smoke shops and age-restricted businesses.",
    image: smokeshopProcessing,
    date: "2025-01-17",
    category: "High-Risk Processing",
  },
  {
    slug: "crypto-pos-guide",
    title: "The Future is Now: Why Your Business Should Be Accepting Crypto Payments",
    excerpt:
      "Discover how cryptocurrency payments can reduce fees, eliminate chargebacks, and expand your customer base with easy setup for any business type.",
    image: cryptoPosGuide,
    date: "2025-01-18",
    category: "Cryptocurrency Processing",
  },
  {
    slug: "eliminate-credit-card-processing-fees",
    title: "How Cash Discount Programs Eliminate Credit Card Processing Fees",
    excerpt:
      "Learn how compliant cash discount programs can help your business keep 100% of your profits by offsetting processing costs the right way.",
    image: heroCashDiscountThumb,
    date: "2025-07-01",
    category: "Cash Discount",
  },
  {
    slug: "korona-vs-clover-vs-valor-pos",
    title: "KORONA vs Clover vs Valor: Which POS Fits Your Business?",
    excerpt:
      "A practical comparison of KORONA, Clover, and Valor POS systems—features, pricing, and ideal use cases for retail, restaurants, and services.",
    image: koronaPos,
    date: "2025-07-05",
    category: "POS Systems",
  },
  {
    slug: "increase-margins-with-online-ordering",
    title: "Increase Margins with Online Ordering and DoorDash Savings",
    excerpt:
      "Boost your bottom line with first‑party online ordering and DoorDash Merchant Savings—reduce commissions and own your customer data.",
    image: onlineOrdering,
    date: "2025-07-10",
    category: "Online Ordering",
  },
];
